import { render } from "./category.vue?vue&type=template&id=0ab0c67b&scoped=true&ts=true"
import script from "./category.vue?vue&type=script&lang=ts"
export * from "./category.vue?vue&type=script&lang=ts"

import "./category.vue?vue&type=style&index=0&id=0ab0c67b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab0c67b"]])

export default __exports__